var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleaningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7L14.7778 13.6111",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0133 13.2886C10.0842 14.0285 8.54209 13.9016 7 13.291C7.38935 18.3018 9.72544 20.2291 12.8403 20.9999C12.8403 20.9999 15.187 19.3404 15.5252 15.4057C15.5619 14.9795 15.5802 14.7665 15.4916 14.5264C15.403 14.2863 15.229 14.1141 14.8811 13.7697C14.309 13.2032 14.0229 12.92 13.6834 12.8491C13.3439 12.7783 12.9004 12.9484 12.0133 13.2886Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 17.4582C8.16667 17.4582 10.1111 17.8333 12.0556 16.3333",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2778 10.3055C11.2778 10.8424 10.8425 11.2777 10.3056 11.2777C9.76861 11.2777 9.33334 10.8424 9.33334 10.3055C9.33334 9.76853 9.76861 9.33325 10.3056 9.33325C10.8425 9.33325 11.2778 9.76853 11.2778 10.3055Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2222 7.77783V7.85561",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningIcon);
export default __webpack_public_path__ + "static/media/cleaning_icon.ef24f6db011cf0e269f4fa80ccec5e64.svg";
export { ForwardRef as ReactComponent };